"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openCSVBook = exports.openXLSXBook = void 0;
const xlsx_1 = require("./implementations/xlsx");
const csv_1 = require("./implementations/csv");
function openXLSXBook(workbook) {
    return new xlsx_1.NaiveXLSXBook(workbook);
}
exports.openXLSXBook = openXLSXBook;
function openCSVBook(rows) {
    return new csv_1.NaiveCSVBook(rows);
}
exports.openCSVBook = openCSVBook;
/*
 * export writeTranslation
 * export downloadFile
 * export bookToFile
 * export bookToBlob
 * export bookToRecords
 * export parseCsvRecord
 *
 * rowToRecord
 * bookToRecord
 *
 * class BookParser {
 *   constructor(option: ParseOption) {}
 *   parse(book: Book): Script[];
 * }
 *
 * interface Book {}
 * async function parseXLSX(file: File): Promise<Book>;
 * async function parseCSV(file: File): Promise<Book>;
 * async function* parseGoogleSheet(url: string): AsyncIterable<...>;
 *
 * // XLSX To Book
 * // CSV To Book
 * // Google Sheet To Book
 *
 * // Book To Scripts
 * const scripts = [];
 * for (const sheet of book.sheets) {
 *   const iterator = sheet.getIterator();
 *   for (let i = 0; i < options.ignoreLines; i++) iterator.next();
 *
 *   const header = iterator.next();
 *   if (!header) return;
 *
 *   for (const row of iterator) {
 *     const record = new Map({ sheetName: sheet.name, rowNo: row.index });
 *
 *     for (const column of header) {
 *       if (!column.text) continue;
 *       record.set(column.text, row[column.index]);
 *     }
 *
 *     // recordToRow
 *     const script = parseRecord(record);
 *     scripts.push(script);
 *   }
 * }
 */
